// Dashboard Mutations

export const updateCurrentSubLinks = (state, payload) => {
  state.currentSubLinks = payload
}

export const toggleSidebarSubMenu = (state, payload) => {
  state.toggleSidebarSubMenu = payload
}

export const closeSidebarSubMenu = state => {
  state.toggleSidebarSubMenu = false
}

export const updateAppBarTitle = (state, payload) => {
  state.appBarTitle = payload
}

export const updateCashBalance = (state, payload) => {
  state.cashBalance = payload
}

export const setAllBalance = (state, payload) => {
  state.allBalance = payload
}
